import { createFileRoute } from "@tanstack/react-router";
import { QaPage, qaJsonLd } from "@/components/QaPage";
import { breadcrumbJsonLd } from "@/lib/seo-jsonld";
import { LAST_REVIEWED } from "@/lib/official-sources";

const QUESTION = "Vad är en gemensam serveringsyta?";
const SHORT_ANSWER = "Det är en serveringsyta som används av flera tillståndshavare gemensamt, exempelvis i en food court eller på en mässa.";

export const Route = createFileRoute("/fraga/vad-ar-gemensam-serveringsyta")({
  component: () => (
    <QaPage
      breadcrumbs={[
        { label: "Hem", to: "/" },
        { label: "Frågor & svar", to: "/fraga" },
        { label: "Vad är en gemensam serveringsyta" },
      ]}
      question={QUESTION}
      shortAnswer={SHORT_ANSWER}
      body={"Varje tillståndshavare måste ha eget serveringstillstånd, men de delar samma fysiska yta. Det kräver särskild prövning av ordning, ansvar och avgränsning. Reglerna finns i 8 kap. 14 § alkohollagen."}
      source={{ label: "Alkohollagen (2010:1622) – Riksdagen", href: "https://www.riksdagen.se/sv/dokument-och-lagar/dokument/svensk-forfattningssamling/alkohollag-20101622_sfs-2010-1622/" }}
      extraSources={[]}
      deepGuide={{ to: "/serveringstillstand", label: "Tillstånd för delad servering" }}
      related={[{"to": "/fraga/far-jag-ha-uteservering", "label": "Får jag ha uteservering med serveringstillstånd?"}, {"to": "/fraga/hur-soker-jag-uteservering", "label": "Hur söker jag tillstånd för uteservering?"}, {"to": "/fraga/kan-jag-anvanda-pausservering", "label": "Vad är pausservering och vem kan få det?"}]}
      lastReviewed={LAST_REVIEWED}
    />
  ),
  head: () => ({
    meta: [
      { title: "Vad är en gemensam serveringsyta?" },
      { name: "description", content: "Det är en serveringsyta som används av flera tillståndshavare gemensamt, exempelvis i en food court eller på en mässa." },
      { property: "og:title", content: QUESTION },
      { property: "og:description", content: SHORT_ANSWER },
      { property: "og:url", content: "https://alkoholprovet.se/fraga/vad-ar-gemensam-serveringsyta" },
    ],
    links: [{ rel: "canonical", href: "https://alkoholprovet.se/fraga/vad-ar-gemensam-serveringsyta" }],
    scripts: [
      qaJsonLd({
        url: "https://alkoholprovet.se/fraga/vad-ar-gemensam-serveringsyta",
        question: QUESTION,
        answer: SHORT_ANSWER,
      }),
      breadcrumbJsonLd([
        { label: "Hem", url: "https://alkoholprovet.se/" },
        { label: "Frågor & svar", url: "https://alkoholprovet.se/fraga" },
        { label: "Vad är en gemensam serveringsyta", url: "https://alkoholprovet.se/fraga/vad-ar-gemensam-serveringsyta" },
      ]),
    ],
  }),
});
